// src/pages/AboutPage.js

import React from 'react';
import { Link } from 'react-router-dom';  // <-- Import Link for routing
import { Container, Row, Col, Button } from 'react-bootstrap';

function AboutPage() {
  return (
    <>
      {/* ------------------------------------------
          Inline Style to Force Montserrat Globally
          (Remove if using a global CSS file)
      ------------------------------------------- */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');
          
          body, h1, h2, h3, h4, h5, h6, p, .btn, .navbar-brand, .nav-link {
            font-family: 'Montserrat', sans-serif !important;
          }
        `}
      </style>

      {/* ========== ABOUT PAGE HERO BANNER ========== */}
      <div
        style={{
          backgroundColor: '#003f5c',
          color: '#fff',
          padding: '6rem 0',
          textAlign: 'center',
        }}
      >
        <Container>
          <h1 style={{ fontWeight: '700', fontSize: '2.5rem' }}>
            About Benign Fasciculation Syndrome (BFS) Organization
          </h1>
          <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '1rem auto' }}>
            Learn more about our mission, our story, and the people behind BFS advocacy.
          </p>
        </Container>
      </div>

      {/* ========== MISSION & VISION SECTION ========== */}
      <div style={{ backgroundColor: '#f5f5f5', padding: '4rem 0' }}>
        <Container>
          <Row className="justify-content-center text-center mb-4">
            <Col md={8}>
              <h2 style={{ fontWeight: '700', fontSize: '2rem', marginBottom: '1.5rem' }}>
                Our Mission & Vision
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                We strive to empower individuals living with BFS through education, community support,
                and innovative research. Our vision is a world in which Benign Fasciculation Syndrome is
                widely recognized and effectively managed—reducing anxiety and improving quality of life
                for those affected.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ========== OUR STORY SECTION ========== */}
      <div style={{ backgroundColor: '#fff', padding: '4rem 0' }}>
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="mb-4 mb-md-0">
              <img
                src="https://images.pexels.com/photos/3184437/pexels-photo-3184437.jpeg"
                alt="Team discussion"
                style={{ width: '100%', borderRadius: '8px', objectFit: 'cover' }}
              />
            </Col>
            <Col md={6}>
              <h3 style={{ fontWeight: '700', marginBottom: '1rem' }}>
                Our Story
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Founded in 2023, the BFS Organization began as a small online forum where individuals
                dealing with muscle twitching could find reassurance. Over time, we expanded into a global
                community, dedicated to connecting patients, caregivers, and medical professionals. Today,
                we continue to grow in scope—raising funds for research, launching awareness campaigns,
                and offering inclusive support for anyone affected by BFS.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ========== JOIN US / CTA SECTION ========== */}
      <div style={{ backgroundColor: '#c8102e', color: '#fff', padding: '4rem 0', textAlign: 'center' }}>
        <Container>
          <Row>
            <Col>
              <h2 style={{ fontWeight: '700', marginBottom: '1rem', fontSize: '2rem' }}>
                Join Us in Our Mission
              </h2>
              <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '0 auto' }}>
                Whether you’re a patient, caregiver, medical professional, or volunteer, there’s a place
                for you in the BFS Organization. Together, we can make a difference.
              </p>
              {/* "Get Involved" => /donate */}
              <Button
                variant="light"
                className="fw-semibold rounded-pill mt-4"
                as={Link}
                to="/donate"
              >
                Get Involved
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default AboutPage;
